import React from 'react';
import { Card, CardContent, CardHeader } from '@/components/ui/card';

const DashboardSkeleton = () => {
    return (
        <div className="p-6 md:p-8 space-y-8 max-w-[1600px] mx-auto animate-pulse">
            {/* Header Skeleton */}
            <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-6">
                <div className="space-y-2">
                    <div className="h-10 w-64 bg-slate-200 dark:bg-slate-800 rounded-lg"></div>
                    <div className="h-4 w-96 bg-slate-200 dark:bg-slate-800 rounded-lg"></div>
                </div>
                <div className="flex gap-3">
                    <div className="h-11 w-40 bg-slate-200 dark:bg-slate-800 rounded-xl"></div>
                    <div className="h-11 w-40 bg-slate-200 dark:bg-slate-800 rounded-xl"></div>
                </div>
            </div>

            {/* Alert Bar Skeleton */}
            <div className="h-20 w-full bg-slate-200 dark:bg-slate-800 rounded-2xl"></div>

            {/* KPIs Grid Skeleton */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                {[1, 2, 3, 4].map((i) => (
                    <Card key={i} className="border-l-4 border-slate-200 bg-white dark:bg-slate-900">
                        <CardContent className="p-5 space-y-4">
                            <div className="flex justify-between">
                                <div className="space-y-2">
                                    <div className="h-3 w-20 bg-slate-100 dark:bg-slate-800 rounded"></div>
                                    <div className="h-8 w-16 bg-slate-200 dark:bg-slate-800 rounded"></div>
                                </div>
                                <div className="w-10 h-10 bg-slate-100 dark:bg-slate-800 rounded-xl"></div>
                            </div>
                            <div className="h-3 w-32 bg-slate-100 dark:bg-slate-800 rounded"></div>
                        </CardContent>
                    </Card>
                ))}
            </div>

            {/* Middle Grid Skeleton */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {[1, 2, 3].map((i) => (
                    <div key={i} className="h-[450px] bg-slate-200 dark:bg-slate-800 rounded-2xl"></div>
                ))}
            </div>
        </div>
    );
};

export default DashboardSkeleton;
